import { Producto } from "./producto";

export class OrdenCompraDetalle {
    public constructor(
        public id: String = "",
        public cantidad: number = 0,
        public descripcion: String = "",
        public codigo: String = "",
        public producto: Producto = new Producto(),
        public unidad: String = "",
        //
        // public es_servicio: boolean = false,
        public tipo_producto_id: string = "",
        public cantidad_stock: number = 0,
        public precio_unitario: number = 0,
        public graba_iva: boolean = false,
        public detalle: String = "",
        public desc_valor: number = 0,
        public desc_porcent: number = 0,
        public subtotal: number = 0,
        public iva:number = 0,
        public total: number = 0,
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public producto_id: String = "", 
        public proforma_id: String = "", 
        public usuario_id:String = null
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/orden-compra-detalle.ts